var SCM = SCM || {};

(function (sa, $) {

    sa.init = function () {
        let $seeAlsoWidgets = $('.widget-SeeAlso');
        if (!$seeAlsoWidgets.length) {
            return;
        }
        $seeAlsoWidgets.each(function () {
            let $this = $(this);
            let $viewMoreLinkDiv = $this.find('.js-view-more-div');
            let $viewLessLinkDiv = $this.find('.js-view-less-div');
            let $viewMoreLink = $this.find('.js-view-more-div > .js-view-more-a');
            let $viewLessLink = $this.find('.js-view-less-div > .js-view-less-a');
            let $rowsToHideUnhide = $this.find('li.js-more');
            if ($viewMoreLink.length) {
                $viewMoreLink.on('click', function () {
                    $rowsToHideUnhide.removeClass('hide');
                    $viewLessLinkDiv.removeClass('hide');
                    $viewMoreLinkDiv.addClass('hide');
                });
            }
            if ($viewLessLink.length) {
                $viewLessLink.on('click', function () {
                    $rowsToHideUnhide.addClass('hide');
                    $viewLessLinkDiv.addClass('hide');
                    $viewMoreLinkDiv.removeClass('hide');
                });
            }
        });
    };
})(SCM.SeeAlso = SCM.SeeAlso || {}, jQuery);
